/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_FAMILY_PLANNING_DRUG_PMT_REC_DISPLAY =
  'REFRESH_FAMILY_PLANNING_DRUG_PMT_REC_DISPLAY';
export const GET_ERROR_MSG_QUARTERLY_PAYMENT =
  'GET_ERROR_MSG_QUARTERLY_PAYMENT';

export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT';
export const IS_LOADING = 'IS_LOADING';
export const REFRESH_FAMILY_PLANNING_DRUG_PMT_REC =
  'REFRESH_FAMILY_PLANNING_DRUG_PMT_REC';
export const SET_FAMILY_PLANNING_DRUG_PMT_REC_DATA =
  'SET_FAMILY_PLANNING_DRUG_PMT_REC_DATA';
